import React, { useContext, useState } from "react";
import { FixtureDetailsContext } from "../../Config/FixtureDetails";
import FreshChat from "./FreshChat";

const ChatContext = React.createContext({});

export const ChatProvider = ({ children, currentState }) => {
  const { sport } = useContext(FixtureDetailsContext);

  const [chatClient, setChatClient] = useState(null);

  const handleChatInit = (client) => {
    setChatClient(client);
  };

  return (
    <ChatContext.Provider value={chatClient}>
      <>{children}</>
      {sport === "handball" && <FreshChat currentState={currentState} onInit={handleChatInit} />}
    </ChatContext.Provider>
  );
};
